import { render, staticRenderFns } from "./WxpayInfo.vue?vue&type=template&id=7e31d38a&scoped=true"
import script from "./WxpayInfo.vue?vue&type=script&lang=js"
export * from "./WxpayInfo.vue?vue&type=script&lang=js"
import style0 from "./WxpayInfo.vue?vue&type=style&index=0&id=7e31d38a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e31d38a",
  null
  
)

export default component.exports